import {
  OrderCargoOrderDetailsComplexSolveNode,
  OrderCargoOrderDetailsComplexTransportingOrder,
} from "../../../../common/services/order/cargo-order/details-complex/order-cargo-order-details-complex";
import OrderDetailsRouteWaypoint from "./types/order-details-route-waypoint";

const createOrderDetailsWaypointForSolvedOrderRide = (
  responseRideWaypoint: OrderCargoOrderDetailsComplexSolveNode,
  stageNo: number,
  markerPosition: number,
  completionDate: Date | null,
): OrderDetailsRouteWaypoint => {
  return {
    haltingTime: responseRideWaypoint.requestedHaltingTime,
    onboardingPassengersUuids: responseRideWaypoint.cargoEnter,
    outboardingPassengersUuids: responseRideWaypoint.cargoExit,
    orderedDate: responseRideWaypoint.requestedTime,
    place: {
      displayName: responseRideWaypoint.displayName,
      latitude: responseRideWaypoint.lat,
      longitude: responseRideWaypoint.lon,
    },
    stageNo,
    markerPosition,
    completionDate,
    distance: responseRideWaypoint.distance,
    estimatedDate: responseRideWaypoint.estimatedTime,
  };
};

const createOrderDetailsWaypointsFromSolvedOrders = (
  responseTransportingOrders: OrderCargoOrderDetailsComplexTransportingOrder[],
  responseSolvedOrders: OrderCargoOrderDetailsComplexSolveNode[],
): OrderDetailsRouteWaypoint[] => {
  let waypoints: OrderDetailsRouteWaypoint[] = [];

  responseSolvedOrders.forEach((sequenceItem, index) => {
    const completionDateString = responseTransportingOrders
      .find((transportingOrder) =>
        transportingOrder?.driverSolve?.find(
          (item) => item.nodeId === sequenceItem.nodeId,
        ),
      )
      ?.driverSolve?.find((item) => item.nodeId === sequenceItem.nodeId)
      ?.checkoutEvent?.achievedAt;

    const completionDate = completionDateString
      ? new Date(completionDateString)
      : null;

    const isRouteResolved = responseTransportingOrders.every(
      (order) =>
        order.solve.every((item) => !Array.isArray(item)) || !!order.driver,
    );

    let stageNo = 0;

    responseTransportingOrders.forEach((transportingOrder) =>
      transportingOrder.solve.forEach((item, index) => {
        if (Array.isArray(item)) {
          const containsOrder = item.some(
            (order) => order.nodeId === sequenceItem.nodeId,
          );

          if (containsOrder) {
            stageNo = index + 1;
          }
        } else {
          if (item.nodeId === sequenceItem.nodeId) {
            stageNo = index + 1;
          }
        }
      }),
    );

    const markerPosition = isRouteResolved ? index + 1 : stageNo;

    const newWaypoint = createOrderDetailsWaypointForSolvedOrderRide(
      sequenceItem,
      stageNo,
      markerPosition,
      completionDate,
    );

    waypoints = [...waypoints, newWaypoint];
  });

  return waypoints;
};

const createWaypoints = (
  responseTransportingOrders: OrderCargoOrderDetailsComplexTransportingOrder[],
): OrderDetailsRouteWaypoint[] => {
  const solvedOrdersFromAllTransportingOrders = responseTransportingOrders
    .map((item) => item.solve.flat())
    .flat();

  const waypoints = createOrderDetailsWaypointsFromSolvedOrders(
    responseTransportingOrders,
    solvedOrdersFromAllTransportingOrders,
  );

  return waypoints;
};

const orderDetailsWaypointFactory = {
  createWaypoints,
};

export default orderDetailsWaypointFactory;
